<li>
    <a href="" aria-label="Eventi Cancelleria">Eventi Cancelleria</a>
</li>
